"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useTracking } from "react-tracking";
import { StyledTab } from "./styles.js";
import { getDataTestId } from "../../../Util/index.js";
const COMPONENT_NAME = "Tab";
const Tab = forwardRef((props, ref) => {
  const { ariaControls, id, isLastTab = false, label, ...rest } = props;
  const { trackEvent } = useTracking();
  const onClickHandler = (_event) => {
    trackEvent();
  };
  if (!ariaControls || !label || !id) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    StyledTab,
    {
      ...rest,
      "aria-controls": ariaControls,
      "data-testid": getDataTestId(COMPONENT_NAME, id),
      "data-text": label,
      id,
      isLastTab,
      label,
      onClick: onClickHandler,
      ref
    }
  );
});
Tab.displayName = COMPONENT_NAME;
export {
  Tab
};
